import { Injectable } from '@angular/core';
import { DialogMainComponent, DialogRef } from '../components/dialog-main/dialog-main.component';

@Injectable()
export class DialogService {
    private dialogRef: any;
    constructor(public dialog: DialogRef) {}

    openModal(data: any) {
        if (!data?.data?.hasOwnProperty('ignoreClassName')) {
            data.data.ignoreClassName = 'ck';
        }

        this.dialogRef = this.dialog.open(DialogMainComponent, data);
    }

    returnOpenModal(data: any) {
        return this.dialog.open(DialogMainComponent, data);
    }

    getAfterOpen() {
        return this.dialogRef.afterOpened();
    }

    closeModal() {
        this.dialog.closeAll();
    }
}
